import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QuerySearchModulesArgs,
  SearchModulesOutput,
  Module,
  ModuleConnection,
} from "types/generated";

export type SearchModulesForNavigationItem = Pick<Module, "id" | "name" | "spaceDetails">;

type SearchModulesForNavigationData = {
  searchModules: {
    edges: Array<{
      node: SearchModulesForNavigationItem;
      cursor: ModuleConnection["cursor"];
    }>;
    pageInfo: Pick<SearchModulesOutput["pageInfo"], "hasNextPage">;
  };
};

export const SEARCH_MODULES_FOR_NAVIGATION: TypedDocumentNode<
  SearchModulesForNavigationData,
  QuerySearchModulesArgs
> = gql`
  query SearchModulesForNavigation($input: SearchInput!) {
    searchModules(input: $input) {
      edges {
        node {
          id
          name
          spaceDetails {
            id
            name
            accessLevel
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;
